import { Statistic } from 'antd';

export default Statistic;
